import React from 'react'
import { AvatarGroup as MuiAvatarGroup } from '@mui/material'

import { type AvatarSize } from './Avatar'

interface AvatarGroupProps extends Omit<React.ComponentProps<typeof MuiAvatarGroup>, 'max'> {
  size?: AvatarSize
}

const AvatarGroup: React.FC<AvatarGroupProps> = ({ size, className, ...rest }) => {
  const classes = ['internal-avatar-group', size && `internal-avatar-group--${size}`, className]
    .filter(Boolean)
    .join(' ')

  return <MuiAvatarGroup className={classes} {...rest} />
}

export default AvatarGroup
